export class EnumValue {
    public Name: string;
    public Value: number;
    public Description: string | undefined;
    constructor(name: string, _value: number, description: string | undefined) {
        this.Name = name;
        this.Description = description;
        this.Value = _value;
    }
}